// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backup-page-warning-text {
  font-size: 15px;
  line-height: 1.25;
  margin-top: 12px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/localFileDialog/localFileDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".backup-page-warning-text {\n  font-size: 15px;\n  line-height: 1.25;\n  margin-top: 12px;\n  padding-left: 20px;\n  padding-right: 20px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
